import { lazy } from 'react';

import type { TApplicationRoute } from '@modules/core/types';

import { HELP_CENTER_ROUTE_PATHS } from './config';

export const QUICK_ACTIONS_ROUTES: TApplicationRoute[] = [
  {
    id: 'help-center-quick-actions',
    path: HELP_CENTER_ROUTE_PATHS.quickActions,
    component: lazy(() => import('./pages/quick-actions-page')),
    layout: 'default',
    permissions: { scopes: ['help-center'] },
    menu: {
      title: 'pages.helpCenter.quickActions.title',
    },
  },
];
